import { createFileRoute, redirect } from '@tanstack/react-router'
import { KnowledgeBaseView } from '@/components/knowledge/KnowledgeBaseView'
import {
  knowledgeBaseKbIdSearch,
  parseKnowledgeBaseKbIdSearch,
} from '@/components/knowledge/knowledgeBaseRouteSearch'

export const Route = createFileRoute('/_app/knowledge-base/$kbId')({
  validateSearch: (search: Record<string, unknown>) =>
    parseKnowledgeBaseKbIdSearch(search),
  beforeLoad: ({ location, params, search }) => {
    const rawPath = new URLSearchParams(location.searchStr).get('path')
    if (rawPath !== null && !rawPath.trim()) {
      throw redirect({
        to: '/knowledge-base/$kbId',
        params: { kbId: params.kbId },
        search: knowledgeBaseKbIdSearch({
          ...(search.addFile === '1' ? { addFile: '1' as const } : {}),
          ...(search.view === 'graph' ? { view: 'graph' as const } : {}),
        }),
        replace: true,
      })
    }
  },
  component: KnowledgeBaseKbIdLayoutRoute,
})

function KnowledgeBaseKbIdLayoutRoute() {
  const { kbId } = Route.useParams()
  const { path, view } = Route.useSearch()
  const fileHistoryPath = path?.trim() || undefined
  return (
    <KnowledgeBaseView
      kbId={kbId}
      fileHistoryPath={fileHistoryPath}
      viewMode={view}
    />
  )
}
